exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "*{-webkit-overflow-scrolling:touch;box-sizing:border-box}html,body{font-family:\"Lato\",\"Helvetica\",\"Arial\",sans-serif;font-size:62.5%;color:#313537;-webkit-font-smoothing:antialiased}body,div,span,h1,h2,h3,h4,h5,h6,p{margin:0}", ""]);

